module.exports = __webpack_public_path__ + "media/images/home/concept_scene_4_sp-9230f0d596e5c271b6b4356b3c9de1f2.png";